module.exports = __webpack_public_path__ + "img/bottom_people_002.878b92a4.svg";